'use client';
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import GallerySection from './components/GallerySection';
import ComparisonSection from './components/ComparisonSection';
import ServiceTiersSection from './components/ServiceTiersSection';
import BookingSection from './components/BookingSection';
import DespreNoiSection from './components/DespreNoiSection';

export default function HomePage() {
  // Scroll progress bar
  useEffect(() => {
    const bar = document.createElement('div');
    bar.className = 'scroll-progress';
    bar.style.width = '0%';
    document.body?.appendChild(bar);

    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement?.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = `${pct}%`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (bar?.parentNode) bar?.parentNode?.removeChild(bar);
    };
  }, []);

  // Global reveal observer
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal:not(.visible)').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 100);
            });
          }
        });
      },
      { threshold: 0.08 }
    );
    document.querySelectorAll('section')?.forEach((s) => obs?.observe(s));
    return () => obs?.disconnect();
  }, []);

  return (
    <div style={{ background: 'var(--cockpit-black)', minHeight: '100vh' }}>
      <Header />
      <main>
        <HeroSection />

        <div className="section-divider" />

        <GallerySection />

        <div className="section-divider" />

        <ComparisonSection />

        <div className="section-divider" />

        <ServiceTiersSection />

        <div className="section-divider" />

        <DespreNoiSection />

        <div className="section-divider" />

        <BookingSection />
      </main>
      <Footer />
    </div>
  );
}